import * as Types from '../types';

interface FetchUserRolesAction {
  type: string;
}

interface UserRolesLoadedAction {
  type: string;
  payload: { roles: string[] };
}

export const fetchUserRoles = (): FetchUserRolesAction => ({
  type: Types.FETCH_USER_ROLES,
});

export const userRolesLoaded = (roles: string[]): UserRolesLoadedAction => ({
  type: Types.USER_ROLES_LOADED,
  payload: { roles },
});
